import { PatchProducts } from '../../actions/list/patch.actions';

export function reversePatchItemsToAdd(patchProducts: PatchProducts) {
  const { patchModel } = patchProducts;
  const itemsToAdd = patchModel.itemsToAdd;

  if (itemsToAdd.length > 0) {
    return {
      ...patchProducts,
      patchModel: {
        ...patchModel,
        itemsToAdd: [...itemsToAdd].reverse(),
      },
    };
  }

  return patchProducts;
}
